import { render, staticRenderFns } from "./CompetitionRanking.vue?vue&type=template&id=8b6e03cc&scoped=true"
import script from "./CompetitionRanking.vue?vue&type=script&lang=js"
export * from "./CompetitionRanking.vue?vue&type=script&lang=js"
import style0 from "./CompetitionRanking.vue?vue&type=style&index=0&id=8b6e03cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6e03cc",
  null
  
)

export default component.exports